
import React from 'react';
import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { SPORTS_LIST } from '@/data/sportsData';

interface CoachSportsPreferencesSectionProps {
  preferredSports: string[];
  onSportsChange: (sport: string, checked: boolean) => void;
}

export const CoachSportsPreferencesSection: React.FC<CoachSportsPreferencesSectionProps> = ({
  preferredSports,
  onSportsChange
}) => {
  return (
    <Card className="bg-gray-700 border-gray-600">
      <CardHeader>
        <CardTitle className="text-white text-lg">Additional Sports Experience</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 max-h-60 overflow-y-auto">
          {SPORTS_LIST.map((sport) => (
            <div key={sport} className="flex items-center space-x-2">
              <Checkbox
                id={sport}
                checked={preferredSports.includes(sport)}
                onCheckedChange={(checked) => onSportsChange(sport, Boolean(checked))}
              />
              <Label htmlFor={sport} className="text-gray-300 text-sm cursor-pointer">
                {sport}
              </Label>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
